import { Path, Svg } from './styles';

interface AdminSettingsProps {
  height?: string;
  width?: string;
  strokeWidth?: string;
  color?: string;
  variant?: 'primary' | 'secondary';
}

export const AdminSettings = ({
  height = '3.75rem',
  width = '3rem',
  strokeWidth = '1',
  color,
  variant,
}: AdminSettingsProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31 31"
    width={width}
    height={height}
  >
    <Path
      d="M26.145 16.47C26.205 15.99 26.25 15.51 26.25 15C26.25 14.49 26.205 14.01 26.145 13.53L29.31 11.055C29.595 10.83 29.67 10.425 29.49 10.095L26.49 4.905C26.355 4.665 26.1 4.53 25.83 4.53C25.74 4.53 25.65 4.545 25.575 4.575L21.84 6.075C21.06 5.475 20.22 4.98 19.305 4.605L18.735 0.63C18.69 0.27 18.375 0 18 0H12C11.625 0 11.31 0.27 11.265 0.63L10.695 4.605C9.78 4.98 8.94 5.49 8.16 6.075L4.425 4.575C4.335 4.545 4.245 4.53 4.155 4.53C3.9 4.53 3.645 4.665 3.51 4.905L0.510003 10.095C0.315003 10.425 0.405003 10.83 0.690003 11.055L3.855 13.53C3.795 14.01 3.75 14.505 3.75 15C3.75 15.495 3.795 15.99 3.855 16.47L0.690003 18.945C0.405003 19.17 0.330003 19.575 0.510003 19.905L3.51 25.095C3.645 25.335 3.9 25.47 4.17 25.47C4.26 25.47 4.35 25.455 4.425 25.425L8.16 23.925C8.94 24.525 9.78 25.02 10.695 25.395L11.265 29.37C11.31 29.73 11.625 30 12 30H18C18.375 30 18.69 29.73 18.735 29.37L19.305 25.395C20.22 25.02 21.06 24.51 21.84 23.925L25.575 25.425C25.665 25.455 25.755 25.47 25.845 25.47C26.1 25.47 26.355 25.335 26.49 25.095L29.49 19.905C29.67 19.575 29.595 19.17 29.31 18.945L26.145 16.47ZM23.175 13.905C23.235 14.37 23.25 14.685 23.25 15C23.25 15.315 23.22 15.645 23.175 16.095L22.965 17.79L24.3 18.84L25.92 20.1L24.87 21.915L22.965 21.15L21.405 20.52L20.055 21.54C19.41 22.02 18.795 22.38 18.18 22.635L16.59 23.28L16.35 24.975L16.05 27H13.95L13.665 24.975L13.425 23.28L11.835 22.635C11.19 22.365 10.59 22.02 9.99 21.57L8.625 20.52L7.035 21.165L5.13 21.93L4.08 20.115L5.7 18.855L7.035 17.805L6.825 16.11C6.78 15.645 6.75 15.3 6.75 15C6.75 14.7 6.78 14.355 6.825 13.905L7.035 12.21L5.7 11.16L4.08 9.9L5.13 8.085L7.035 8.85L8.595 9.48L9.945 8.46C10.59 7.98 11.205 7.62 11.82 7.365L13.41 6.72L13.65 5.025L13.95 3H16.035L16.32 5.025L16.56 6.72L18.15 7.365C18.795 7.635 19.395 7.98 19.995 8.43L21.36 9.48L22.95 8.835L24.855 8.07L25.905 9.885L24.3 11.16L22.965 12.21L23.175 13.905ZM15 9C11.685 9 9 11.685 9 15C9 18.315 11.685 21 15 21C18.315 21 21 18.315 21 15C21 11.685 18.315 9 15 9ZM15 18C13.35 18 12 16.65 12 15C12 13.35 13.35 12 15 12C16.65 12 18 13.35 18 15C18 16.65 16.65 18 15 18Z"
      fill={color}
      variant={variant}
      strokeWidth={strokeWidth}
    />
  </Svg>
);
